import { render } from "./DefaultBox.vue?vue&type=template&id=db13776c"
import script from "./DefaultBox.vue?vue&type=script&lang=js"
export * from "./DefaultBox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Astronation\\artstation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__